

import React from 'react';
import Tokens from '@nokia-csf-uxr/freeform-design-tokens';

import IconButton from 'components/IconButton';

const BUTTON_STYLE = {
  padding: `0 ${Tokens.SPACING.SPACING_2}`
};

export interface TextInputButtonProps extends React.ComponentPropsWithRef<'button'> {
  /** An Icon component. */
  children: React.ReactElement;
  /** If `true`, the button will be disabled. */
  disabled?: boolean;
}

/** Any other props than `children` will be provided to the <Button /> component. */
const TextInputButton = React.forwardRef<HTMLElement, TextInputButtonProps>((props: TextInputButtonProps, ref) => {
  const {
    disabled,
    children,
    ...otherProps
  } = props;
  return (
    <IconButton
      {...otherProps}
      disabled={disabled}
      style={BUTTON_STYLE}
      ref={ref}
    >
      {children}
    </IconButton>);
});

TextInputButton.defaultProps = {
  disabled: false,
};

TextInputButton.displayName = 'TextInputButton';

export default TextInputButton;
